import { Link } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";

export default function Landing() {
  const { user } = useAuth();
  const dashboardHref = user ? "/dashboard" : "/login";

  return (
    <div className="min-h-screen bg-[#0B0E14] text-white overflow-hidden relative" data-testid="landing-page">
      <div className="absolute inset-0 pointer-events-none" style={{ backgroundImage: "radial-gradient(circle at 15% 10%, rgba(99,102,241,0.25), transparent 45%), radial-gradient(circle at 85% 30%, rgba(16,185,129,0.18), transparent 40%)" }} />

      <nav className="relative z-10 max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <span className="font-display font-black text-xl tracking-tight">SmartLinks</span>
        <div className="flex items-center gap-3">
          <Link to={dashboardHref} data-testid="nav-dashboard-link">
            <Button className="bg-indigo-500 hover:bg-indigo-600 rounded-full px-5">{user ? "Dashboard" : "Log in"}</Button>
          </Link>
        </div>
      </nav>

      <main className="relative z-10 max-w-5xl mx-auto px-6 pt-16 pb-24 text-center space-y-8">
        <p className="inline-block px-4 py-1.5 rounded-full border border-white/15 text-xs uppercase tracking-widest text-emerald-400 font-semibold">
          One link. Every platform. All the clicks.
        </p>
        <h1 className="font-display font-black tracking-tight leading-[1.05] text-4xl sm:text-5xl lg:text-6xl">
          Turn every release & show<br /> into one <span className="text-indigo-400">smart link</span>.
        </h1>
        <p className="text-base sm:text-lg text-slate-400 max-w-2xl mx-auto">
          Build a single, beautiful landing page for your music release or tour — auto-styled artwork,
          every streaming link and ticket stop in one tap, and click analytics that show you what's converting.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center pt-4">
          <Link to={dashboardHref} data-testid="landing-cta-login-button">
            <Button size="lg" className="bg-indigo-500 hover:bg-indigo-600 rounded-full px-8 h-12 text-base font-bold">
              {user ? "Go to Dashboard" : "Log in"}
            </Button>
          </Link>
        </div>

        <div className="grid sm:grid-cols-3 gap-5 pt-16 text-left">
          {[
            { icon: "fa-solid fa-palette", title: "Adaptive artwork colors", desc: "Paste a Spotify link or upload art — your page's colors adapt instantly." },
            { icon: "fa-solid fa-chart-line", title: "Per-link analytics", desc: "See exactly which platform or ticket stop fans are tapping." },
            { icon: "fa-solid fa-bullseye", title: "Meta Pixel built-in", desc: "Fire your own pixel on every page view and click for ad campaigns." },
          ].map((f) => (
            <div key={f.title} className="rounded-2xl border border-white/10 bg-white/[0.03] p-6 space-y-2">
              <i className={`${f.icon} text-indigo-400 text-xl`} />
              <h3 className="font-bold font-display">{f.title}</h3>
              <p className="text-sm text-slate-400">{f.desc}</p>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
}
